import { createContext, useContext } from 'react';

interface WaitlistPanelContextValue {
    /** Hides the panel, keeping its state, while a full window (the client page) is shown. */
    setHidden: (hidden: boolean) => void;
}

export const WaitlistPanelContext = createContext<WaitlistPanelContextValue>({ setHidden: () => undefined });

export const useWaitlistPanel = () => useContext(WaitlistPanelContext);
